import React, {Component} from "react";
import moment from "moment";
import "moment/locale/zh-cn";
import plus from './../images/calendar_plus.png'

moment.locale("zh-cn");

class Calendar extends Component {
  state = {
    cur_year: "",
    cur_month: "",
    days: [],
    hasEmptyGrid: false,
    empytGrids: []
  };

  componentDidMount() {
    this.setNowDate();
  }

  // 设置当前时间
  setNowDate() {
    const {index} = this.props;
    const date = new Date();
    let cur_year = date.getFullYear();
    let cur_month = date.getMonth() + 1;
    const todayIndex = date.getDate() - 1;
    let newMonth = cur_month + index;
    let newYear = cur_year;
    if (newMonth > 12) {
      newYear = cur_year + 1;
      newMonth = newMonth - 12;
    }
    this.calculateEmptyGrids(newYear, newMonth);
    this.calculateDays(newYear, newMonth);
    this.setState({
      cur_year: newYear,
      cur_month: newMonth,
      todayIndex
    });
  }

  // 计算空了的日子
  calculateEmptyGrids(year, month) {
    const firstDayOfWeek = this.getFirstDayOfWeek(year, month);
    console.info(year, month, firstDayOfWeek)
    let empytGrids = [];
    if (firstDayOfWeek > 0) {
      for (let i = 0; i < firstDayOfWeek; i++) {
        empytGrids.push(i);
      }
      this.setState({
        hasEmptyGrid: true,
        empytGrids
      });
    } else {
      this.setState({
        hasEmptyGrid: false,
        empytGrids: []
      });
    }
  }

  // push日子进去
  calculateDays(year, month) {
    let days = [];
    const thisMonthDays = this.getThisMonthDays(year, month);
    for (let i = 1; i <= thisMonthDays; i++) {
      days.push(i);
    }
    this.setState({
      days
    });
  }

  // 获取这个月有几天
  getThisMonthDays(year, month) {
    return new Date(year, month, 0).getDate();
  }

  // 获取第一天是星期几
  getFirstDayOfWeek(year, month) {
    return new Date(Date.UTC(year, month - 1, 1)).getDay();
  }

  // 获取最后一天是星期几
  getLastDayOfWeek(year, month) {
    return new Date(Date.UTC(year, month, 0)).getDay();
  }

  render() {
    const {cur_year, cur_month} = this.state;
    const {showArrange} = this.props;
    let _this = this;
    var current = new Date(`${cur_year}-${cur_month}`);
    return (
      <div className="calendar-view">
        <div className="calendar-top">
          <div className='lt' onClick={function () {

            current.setMonth(current.getMonth() - 1);
            console.log(current.getMonth())
            _this.calculateEmptyGrids(current.getFullYear(), current.getMonth() + 1);


            _this.setState({
              cur_year: current.getFullYear(),
              cur_month: current.getMonth() + 1,
            });
            _this.calculateDays(current.getFullYear(), current.getMonth() + 1)

          }}> &lt; </div>
          <div className="calendar-date">
            {cur_year || "--"} 年 {cur_month || "--"} 月
          </div>
          <div className='gt' onClick={function () {
            current.setMonth(current.getMonth() + 1);
            console.log(current.getMonth())
            _this.calculateEmptyGrids(current.getFullYear(), current.getMonth() + 1);
            _this.setState({
              cur_year: current.getFullYear(),
              cur_month: current.getMonth() + 1
            });
            _this.calculateDays(current.getFullYear(), current.getMonth() + 1)

          }}> &gt; </div>
        </div>
        <div>
        </div>
        {this.renderDate()}
        <div className="calendar-top">
          <div className="calendar-today" onClick={function () {
            current = new Date();
            _this.setState({
              cur_year: current.getFullYear(),
              cur_month: current.getMonth() + 1
            });
            _this.calculateDays(current.getFullYear(), current.getMonth() + 1)
          }}>今天
          </div>
        </div>
        <div className="date-arrangement" onClick={() => this.props.hideArrangeView()}
             style={{transform: showArrange ? "scale(1)" : "scale(0)"}}>
          {this.renderArrangements()}
        </div>
      </div>
    );
  }

  renderDate() {
    const {hasEmptyGrid, days, empytGrids, cur_year, cur_month} = this.state;
    const {arrangementTime} = this.props;
    var toTM = new Date();
    var flag = toTM.getFullYear() === cur_year && toTM.getMonth() + 1 === cur_month;
    var today = toTM.getDate();

    return (
      <div className="date-bg">
        {["日", "一", "二", "三", "四", "五", "六"].map((day, idx) => {
          return (
            <div className="detail-date">
              <div className="detail-date-div">
                <span>{day}</span>
              </div>
            </div>
          );
        })}
        {hasEmptyGrid && empytGrids.map((day, idx) => {
          let data = new Date(`${cur_year}/${cur_month}/1`)
          data.setDate(idx - empytGrids.length + 1);
          let timeStamp = moment(data).valueOf();
          return (<div key={idx} className="detail-date"
                       onClick={e => this.props.showArrangeView(e, arrangementTime[timeStamp], timeStamp)}>
            <div className="detail-date-div not-current-month">
              <span>{data.getDate()}</span>
              {arrangementTime && arrangementTime[timeStamp] !== undefined && (
                <div style={{lineHeight: "1px", position: "absolute", width: "100%"}}>
                  {arrangementTime[timeStamp].map((data, dataIndex) => {
                    if (dataIndex < 3) {
                      return <div key={dataIndex} className="arrange-point"></div>;
                    } else if (dataIndex === 3) {
                      return <img src={plus}/>;
                    }
                  })}
                </div>)}
            </div>
          </div>);
          /*

           */
          return <div key={idx} className="detail-date">
            <div className="detail-date-div">
              <span></span>
            </div>
          </div>;
        })}
        {days.map((day, idx) => {
          let timeStamp = moment([cur_year, cur_month - 1, day]).valueOf();
          const fg = flag && today === day;
          return (<div key={idx} className="detail-date"
                       onClick={e => this.props.showArrangeView(e, arrangementTime[timeStamp], timeStamp)}>
            <div className="detail-date-div">
              {(() => {
                if (fg) {
                  return <span className={'today'}>{day}</span>
                } else {
                  return <span>{day}</span>
                }
              })()}
              {arrangementTime && arrangementTime[timeStamp] !== undefined && (
                <div style={{lineHeight: "1px", position: "absolute", width: "100%"}}>
                  {arrangementTime[timeStamp].map((data, dataIndex) => {
                    if (dataIndex < 3) {
                      return <div key={dataIndex} className="arrange-point"></div>;
                    } else if (dataIndex === 3) {
                      return <img src={plus}/>;
                    }
                  })}
                </div>)}
            </div>
          </div>);
        })}
        {[0, 1, 2, 3, 4, 5, 6].map((day, idx) => {
          var data = new Date(`${cur_year}/${cur_month}/1`)
          var sy = 7 - (days.length + empytGrids.length) % 7;
          if (idx < sy) {
            data.setMonth(data.getMonth() + 1);
            data.setDate(1 + idx);
            let timeStamp = moment(data).valueOf();
            return (<div key={idx} className="detail-date"
                         onClick={e => this.props.showArrangeView(e, arrangementTime[timeStamp], timeStamp)}>
              <div className="detail-date-div not-current-month">
                <span>{data.getDate()}</span>
                {arrangementTime && arrangementTime[timeStamp] !== undefined && (
                  <div style={{lineHeight: "1px", position: "absolute", width: "100%"}}>
                    {arrangementTime[timeStamp].map((data, dataIndex) => {
                      if (dataIndex < 3) {
                        return <div key={dataIndex} className="arrange-point"></div>;
                      } else if (dataIndex === 3) {
                        return <img src={plus}/>;
                      }
                    })}
                  </div>)}
              </div>
            </div>);
          }
        })}
      </div>
    );
  }

  renderArrangements() {
    const {arrangements} = this.props;
    if (arrangements.length !== 0) {
      return arrangements.sort((a, b) => {
        return moment(a.start) - moment(b.start);
      }).map((arrangement, idx) => {
        const {purpose, description, start, end, name} = arrangement;
        let startTime = moment(start).format("HH:mm");
        let endTime = moment(end).format("HH:mm");
        return (
          <div key={idx} className="date-arrangement-bg">
            <div>{purpose}&nbsp;&nbsp;{name}</div>
            <div>
              {startTime} - {endTime}
            </div>
          </div>
        );
      });
    } else {
      return <div>无预约排期</div>;
    }
  }
}

export default Calendar;
